// import React from 'react';
// import { doc, collection, query, where, onSnapshot } from 'firebase/firestore';
// import { FirebaseContext } from '../index';
// import { useNavigate, useParams } from 'react-router-dom';
// import MsgNetLoading from '../components/MsgNetLoading';
// import CompeticionList from '../components/CompeticionList';
// import TopHeaderMenu from '../components/TopHeaderMenu';
// import IconMap from '../icons/IconMap';

// class EventoDetailScreenClass extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       competiciones: [],
//       isLoading: true,
//       evento: null,
//       rankings: {},
//     };
//     this.unlisten = {};
//   }

//   onClickBack() {
//     this.props.navigate('/');
//   }

//   componentDidMount() {
//     const { db, params } = this.props;
//     const eventoId = parseInt(params.eventoId, 10);

//     if (eventoId) {
//       // Evento
//       const eventoRef = doc(db, 'evento', String(eventoId));
//       this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
//         let evento = snapshot.exists() ? snapshot.data() : null;
//         if (evento) {
//           evento.id = snapshot.id;
//         }
//         this.setState({ evento });
//       });

//       // Competiciones
//       const competicionesQuery = query(
//         collection(db, 'competicion'),
//         where('evento_id', '==', eventoId),
//         where('visible', '==', true)
//       );
//       this.unlisten.competiciones = onSnapshot(competicionesQuery, (snapshot) => {
//         let competiciones = snapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
//         competiciones.sort((a, b) => {
//           return a.hora_inicio - b.hora_inicio;
//         });
//         this.setState({
//           competiciones: competiciones,
//           isLoading: false
//         });
//       });
//     }
//   }

//   componentWillUnmount() {
//     if (this.unlisten.evento) {
//       this.unlisten.evento();
//     }
//     if (this.unlisten.competiciones) {
//       this.unlisten.competiciones();
//     }
//   }

//   render() {
//     const evento = this.state.evento;

//     return (
//       <div>
//         <TopHeaderMenu
//           competicion={evento}
//           onClickBack={this.onClickBack.bind(this)}
//         />

//         {this.state.isLoading ? (
//           <MsgNetLoading />
//         ) : (

//           (evento && evento.visible) ? (
//             (this.state.competiciones && this.state.competiciones.length) ? (
//               <div className="px-5 py-6 max-w-4xl mx-auto">
//                 <CompeticionList competiciones={this.state.competiciones} eventoNombre={evento?.nombre} />

//                 {evento.url_recorridos && (
//                   <div className="mt-8 bg-gray-800 rounded-lg p-4 border border-gray-700">
//                     <a
//                       href={evento.url_recorridos}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center justify-between text-gray-300 hover:text-white transition-colors group"
//                     >
//                       <div className="flex items-center gap-3">
//                         <IconMap className="w-6 h-6 text-white" />
//                         <span className="font-light font-montserrat text-white">Ver recorridos del evento ↗</span>
//                       </div>
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <div className="px-5 py-6 max-w-4xl mx-auto text-center">
//                 <h3 className="text-xl text-gray-300 mt-12">
//                   No existen competiciones activas
//                 </h3>
//               </div>
//             )
//           ) : (
//             <div className="px-5 py-6 max-w-4xl mx-auto text-center font-montserrat">
//               <h2 className="text-xl text-gray-300 mt-12">
//                 No se ha podido encontrar el evento
//               </h2>
//             </div>
//           )
//         )}
//       </div>
//     );
//   }
// }

// // Wrapper funcional para hooks de React Router v6
// function EventoDetailScreen() {
//   const navigate = useNavigate();
//   const params = useParams();
//   const { db } = React.useContext(FirebaseContext);

//   return <EventoDetailScreenClass navigate={navigate} params={params} db={db} />;
// }

// export default EventoDetailScreen;
import React from 'react';
import { doc, collection, query, where, onSnapshot } from 'firebase/firestore';
import { FirebaseContext } from '../index';
import { useNavigate, useParams } from 'react-router-dom';
import MsgNetLoading from '../components/MsgNetLoading';
import CompeticionList from '../components/CompeticionList';
import TopHeaderMenu from '../components/TopHeaderMenu';
import IconMap from '../icons/IconMap';

class EventoDetailScreenClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      competiciones: [],
      isLoading: true,
      evento: null,
      rankings: {},
    };
    this.unlisten = {};
  }

  onClickBack() {
    const { navigate } = this.props;
    navigate('/');
  }

  componentDidMount() {
    const { db, params } = this.props;
    const eventoId = parseInt(params.eventoId, 10);

    // Validar que eventoId es un número válido
    if (!eventoId || isNaN(eventoId)) {
      this.setState({
        isLoading: false,
        evento: null
      });
      return;
    }

    // Evento
    const eventoRef = doc(db, 'evento', String(eventoId));
    this.unlisten.evento = onSnapshot(
      eventoRef,
      (snapshot) => {
        let evento = snapshot.exists() ? snapshot.data() : null;
        if (evento) {
          evento.id = snapshot.id;
        }
        this.setState({ evento });
      },
      (error) => {
        console.error('Error al cargar evento:', error);
        this.setState({
          isLoading: false,
          evento: null
        });
      }
    );

    // Competiciones
    const competicionesQuery = query(
      collection(db, 'competicion'),
      where('evento_id', '==', eventoId),
      where('visible', '==', true)
    );
    this.unlisten.competiciones = onSnapshot(
      competicionesQuery,
      (snapshot) => {
        let competiciones = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        competiciones.sort((a, b) => {
          return a.hora_inicio - b.hora_inicio;
        });
        this.setState({
          competiciones: competiciones,
          isLoading: false
        });
      },
      (error) => {
        console.error('Error al cargar competiciones:', error);
        this.setState({
          isLoading: false
        });
      }
    );
  }

  componentWillUnmount() {
    if (this.unlisten.evento) {
      this.unlisten.evento();
    }
    if (this.unlisten.competiciones) {
      this.unlisten.competiciones();
    }
  }

  render() {
    const evento = this.state.evento;

    return (
      <div>
        <TopHeaderMenu
          competicion={evento}
          onClickBack={this.onClickBack.bind(this)}
        />

        {this.state.isLoading ? (
          <MsgNetLoading />
        ) : (

          (evento && evento.visible) ? (
            (this.state.competiciones && this.state.competiciones.length) ? (
              <div className="px-5 py-6 max-w-4xl mx-auto">
                <CompeticionList competiciones={this.state.competiciones} eventoNombre={evento?.nombre} />

                {evento.url_recorridos && (
                  <div className="mt-8 bg-gray-800 rounded-lg p-4 border border-gray-700">
                    <a
                      href={evento.url_recorridos}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between text-gray-300 hover:text-white transition-colors group"
                    >
                      <div className="flex items-center gap-3">
                        <IconMap className="w-6 h-6 text-white" />
                        <span className="font-light font-montserrat text-white">Ver recorridos del evento ↗</span>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            ) : (
              <div className="px-5 py-6 max-w-4xl mx-auto text-center">
                <h3 className="text-xl text-gray-300 mt-12">
                  No existen competiciones activas
                </h3>
              </div>
            )
          ) : (
            <div className="px-5 py-6 max-w-4xl mx-auto text-center font-montserrat">
              <h2 className="text-xl font-light text-gray-300 mt-12 mb-6">
                No se ha podido encontrar el evento
              </h2>
              <button
                onClick={() => this.props.navigate('/')}
                className="px-6 py-2 bg-ccnorte hover:bg-red-500 text-white rounded-lg font-montserrat text-sm transition-colors"
              >
                Ir al inicio
              </button>
            </div>
          )
        )}
      </div>
    );
  }
}

// Wrapper funcional para hooks de React Router v6
function EventoDetailScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const { db } = React.useContext(FirebaseContext);

  return <EventoDetailScreenClass navigate={navigate} params={params} db={db} />;
}

export default EventoDetailScreen;